import { useState, useEffect } from 'react';
import { fullscreen } from './fullscreen';

type UseFullscreenReturnType = {
  isSupported: boolean;
  isActive: boolean;
  toggle: () => void;
};

export const useFullscreen = (): UseFullscreenReturnType => {
  const [isActive, setIsActive] = useState(fullscreen.isFullscreen);

  const onFullscreenChange = (): void => {
    setIsActive(fullscreen.isFullscreen);
  };

  useEffect(() => {
    fullscreen.on('change', onFullscreenChange);
    return () => fullscreen.off('change', onFullscreenChange);
  }, []);

  return {
    isSupported: fullscreen.isEnabled,
    isActive,
    toggle: () => void fullscreen.toggle(),
  };
};
